<template>
    <div class="section" v-show="showStatus">
        <h2 class="sectionTitle">Last 50 Vessel Status</h2>
        <div class="sectionContent cardPlacement">
           <div class="logCard" v-for="(s, index) in status" :key="index">
               <router-link :to="{name: 'Vessels', params: {mmsi: s.mmsi}}" class="screenAction"><p>View Vessel</p><img class="icon" :src="require('@/assets/icons/arrow-right.svg')"></router-link>
               <div>
                   <div v-for="obj in formatFields(s)" :key="obj.field" class="dataItem">
                        <p v-if="obj.field === 'MMSI'">{{obj.field}}: <router-link :to="{name: 'Vessels', params: {mmsi: obj.val}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
               </div>
               <div class="centerImage">
                   <img :src="picUrl(s.mmsi)" :id="'mmsi' + s.mmsi" class="vesselPic">
               </div>
           </div>
        </div>
    </div>
</template>

<script>
import { formatDateLT, readFromObj } from '../../helpers/Formatting.js';
import axios from 'axios';

export default {
    name: 'trending-last-status',
    data: () => ({
        showStatus: false,
        status: [],
    }),
    methods: {
        updateInfo: function(status) {
            var globv = this;
            if (status && status.length > 0) {
                globv.status = status.map(x => {
                    x['ingressLT'] = formatDateLT(x['ingress']);
                    x['minuteDelta'] = Math.floor((Date.now() - x['ingress']) / 60000);
                    return x;
                });
            }

            globv.showStatus = globv.status.length > 0;
        },
        formatFields: function(log) {
            let expectedVariables = [
                {
                    varName: "mmsi",
                    fieldName: "MMSI"
                },
                {
                    varName: "name",
                    fieldName: "Name"
                },
                {
                    varName: "ingressLT",
                    fieldName: "Arrival Time"
                },
                {
                    varName: "minuteDelta",
                    fieldName: "Minutes Elapsed"
                }
            ]

            return readFromObj(log, expectedVariables);
        },
        picUrl: function(mmsi) {
            axios.get(`https://www.raptor1.io/images/ships/${mmsi}.jpg`).then( response => {
                if (response) {
                    document.getElementById('mmsi' + mmsi).src = `https://www.raptor1.io/images/ships/${mmsi}.jpg`;
                }
            }).catch((error) => {
                if (error.response.status !== 404) {
                    console.log(error.response);
                }
            });

            return "/logo.png"
        }
    }
}
</script>